
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface EmptyStateProps {
  onAddProvider: () => void;
}

export const EmptyState = ({ onAddProvider }: EmptyStateProps) => {
  return (
    <div className="col-span-full py-20 text-center">
      <p className="text-muted-foreground">No PEO providers found</p>
      <Button 
        onClick={onAddProvider}
        variant="outline"
        className="mt-4"
      >
        <Plus className="mr-2 h-4 w-4" />
        Add Your First PEO Provider
      </Button>
    </div>
  );
};
